'use strict';

const { h } = require('phy');

const CouponsList = require('../../coupons/views/coupons-list-hoc');
const { groupPremiumOffers } = require('../../support/premium-offers-helper');

function MainContent({
  premiumOffers,
  couponsForList,
  routes,
  isTouch,
  categoryId,
  relatedCategories,
  relatedMerchants,
  leaderboardBanner,
}) {
  const { premiumList, couponList } = groupPremiumOffers(
    premiumOffers.concat(couponsForList)
  );

  return [
    h(
      '.category-offers-section',
      {
        'data-bhw': 'CategoryCouponsList',
      },
      CouponsList({
        premium: premiumList,
        coupons: couponList,
        routes,
        isTouch,
        related: {
          parentCategoryId: categoryId,
          categories: relatedCategories,
          merchants: relatedMerchants,
        },
      })
    ),
    !isTouch && leaderboardBanner,
  ];
}

module.exports = MainContent;
